<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row">
        <Input v-model="params.warehouseName" placeholder="仓库名称" clearable style="width: 200px"/>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findwarehouseList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>仓库信息列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findwarehouseList">
                <Icon type="md-refresh" size="15"/>
              </Button>
              <Button @click="showAdminOpe(2)">新增仓库信息</Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

        <template slot-scope="{ row, index }" slot="isDisable">
          <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
          <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
        </template>

        <template slot-scope="{ row }" slot="action">
          <Button type="success" size="small" style="margin-right: 5px" @click="showAdminOpe(1, row)">查看
          </Button>
          <Button type="primary" size="small" style="margin-right: 5px" @click="showAdminOpe(3, row)">编辑
          </Button>
          <Button type="error" size="small" style="margin-right: 5px" @click="isDelUser(row)">删除
          </Button>
<!--          <Dropdown transfer trigger="click">-->
<!--            <Button size="small">-->
<!--              <Icon type="ios-more" size="22"/>-->
<!--            </Button>-->
<!--            <DropdownMenu slot="list">-->
<!--              <DropdownItem v-if="row.isDisable === 0" @click.native="isDisableUser(row)">禁用-->
<!--              </DropdownItem>-->
<!--              <DropdownItem v-if="row.isDisable === 1" @click.native="isDisableUser(row)">启用-->
<!--              </DropdownItem>-->
<!--              <DropdownItem @click.native="isDelUser(row)">删除</DropdownItem>-->
<!--            </DropdownMenu>-->
<!--          </Dropdown>-->
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <!--显示模态框-->
    <warehouse-ope ref="warehouseOpe" @changeDate="findwarehouseList" :areaData="areaData"></warehouse-ope>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import WarehouseOpe from './components/warehouse-ope.vue';

export default {
  name: "admin",
  data() {
    return {
      total: 0,
      isTableLoading: false,
      areaData: [],
      // 参数
      params: {
        page: 1,
        rows: 10,
        warehouseName: '',
        isDisable: ''
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '仓库ID',
          minWidth: 120,
          key: 'warehouseId'
        },
        // 仓库名称
        {
          title: '仓库名称',
          minWidth: 120,
          key: 'warehouseName'
        },
        // 省
        {
          title: '省',
          minWidth: 120,
          key: 'province'
        },
        // 市
        {
          title: '市',
          minWidth: 120,
          key: 'city'
        },
        // 区
        {
          title: '区',
          minWidth: 120,
          key: 'county'
        },
        // 详细地址
        {
          title: '详细地址',
          minWidth: 120,
          key: 'address'
        },
        // 联系人
        {
          title: '联系人',
          minWidth: 120,
          key: 'contact'
        },
        // 手机号
        {
          title: '手机号',
          minWidth: 120,
          key: 'mobile'
        },
        // 仓库状态
        {
          title: '创建时间',
          key: 'createTime',
          width: 150
        },
        {
          title: '操作',
          slot: 'action',
          width: 230,
          align: 'center'
        }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '系统管理', url: '', icon: '', size: 0},
        {name: '仓库管理', url: '', icon: '', size: 0}
      ]
    }
  },
  created() {
    // 仓库信息-列表查询
    this.findwarehouseList();
    // 区域列表-查询
    this.findTreeRegion();
  },
  methods: {
    findTreeRegion() {
      this.axios.post('/region/findTreeRegion').then(res => {
        console.log(res);
        // this.isTableLoading = false;
        if (res.status == 200) {
          this.areaData = res.data
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询区域列表列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 仓库信息-列表查询
    findwarehouseList() {
      this.isTableLoading = true;
      this.axios.post('/warehouse/findList', this.params).then(res => {
        console.log(res);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询仓库信息列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 是否删除仓库信息
    isDelUser(row) {
      // console.log(row)
      this.$Modal.confirm({
        title: `是否删除仓库信息${row.warehouseName}？`,
        onOk: () => {
          // this.$Message.info('您点击了确定.');
          this.deleteAdmin(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    // 删除仓库信息
    deleteAdmin(row) {
      this.$Spin.show();
      this.axios.post('/warehouse/deleteAdmin', {
        warehouseId: row.warehouseId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findwarehouseList();
        }
        if (res.status == 201) {
          // this.$Message.error(res.msg);
          this.$Notice.error({
            title: '删除仓库信息失败',
            desc: res.msg
          });
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '删除仓库信息接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示操作模态框
    showAdminOpe(type, row) {
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      this.$refs.warehouseOpe.show(type, row);
    },
    // 重置筛选条件
    resetScreen() {
      this.params.warehouseName = '';
      this.params.isDisable = '';
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findwarehouseList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findwarehouseList();
    },
  },
  components: {
    WarehouseOpe,
    hsBreadcrumb,
  }
}
</script>

<style scoped>

</style>